<template>
    <div class="row">
      <div class="col-sm-6 order-2-xs">
        <div class="premium-title">
          {{$lang.messages.get_premium_modal.features.title}}
        </div>
        <div class="premium-feature flex" :key=feature.id v-for="feature in features">
          <div class="premium-feature-icon">
            <div :class="'icon-'+ feature.icon"></div>
          </div>
          <div class="premium-feature-content">
            <div class="premium-feature-title text-lg text-bold">{{feature.title}}</div>
            <div class="">
              <span class="premium-feature-text" :key=item.index v-for="item in feature.text">{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="content-block-item -get-premium">
          <div class="modal-title text-center mb-2" v-if="type === 'base'">{{$lang.messages.get_premium_modal.title}}</div>
          <div class="flex flex-wrap-xs" v-if="type === 'base'">
            <label class="radio-wrapper -premium flex-wrap" :class="{active: premiumPlan === 'month'}">
              <input name="premiumPlan" type="radio" class="radio-input" value="month" v-model="premiumPlan">
              <span class="radio-check"></span>
              <span class="radio-label">{{$lang.messages.get_premium_modal.monthly}}</span>
              <span class="w-100"><span class="text-lg text-bold">$2.99 </span><span class="text-sm">per month</span></span>
            </label>
            <label class="radio-wrapper -premium flex-wrap" :class="{active: premiumPlan === 'year'}">
              <input name="premiumPlan" type="radio" class="radio-input" value="year" v-model="premiumPlan">
              <span class="radio-check"></span>
              <span class="radio-label">{{$lang.messages.get_premium_modal.yearly}}</span>
              <span class="premium-sale">{{$lang.messages.get_premium_modal.save_20}}</span>
              <span class="w-100"><span class="text-lg text-bold">$2.41</span> <span class="text-sm">{{$lang.messages.get_premium_modal.per_month}}</span></span>
            </label>
          </div>
          <div class="flex flex-end" v-if="type === 'base'">
            <div class="flex">
              <svg width="52" height="25" viewBox="0 0 52 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M51 21C35.3333 26.1667 4 29.5 4 1.5M4 1.5L0.5 5.5M4 1.5L8 5.5" stroke="#9F81F8"/>
              </svg>
              <div class="premium-label-free">
                <div class="text-thin">{{$lang.messages.get_premium_modal.get}}</div>
                {{$lang.messages.get_premium_modal.two_month_free}}
                </div>
            </div>
          </div>
          <div class="premium-total">
            <div v-if="type === 'trial'" class="w-100">
                <div class="text-lg text-bold mb-1">
                  Subscription details
                </div>
              <div class="w-100 flex-v-center flex-between text-md mb-05">
                Yearly subscription
                <div class="text-bold text-lg">
                  $29
                </div>
              </div>
              <div class="w-100 flex-v-center flex-between text-md mb-05">
                Tax
                <div class="text-bold text-lg">
                  $0
                </div>
              </div>
              <div class="w-100 flex-between text-md mb-05">
                <div>
                  Total billed {{trialEndDate}}
                  <div class="premium-trial-label">
                    We will remind you 2 days before your trial period ends
                  </div>
                </div>
                <div class="text-bold text-lg">
                  $29
                </div>
              </div>

              <div class="divider"></div>
            </div>
            <div class="premium-sale-total" v-if="premiumPlan !== 'month' && type === 'base'">{{$lang.messages.get_premium_modal.percent_off}}</div>
            <div class="w-100 flex-v-center flex-between text-bold">
              <div class="text-lg">{{$lang.messages.get_premium_modal.total}}</div>
              <div v-if="type === 'base'">{{ premiumPlan === 'month' ? '$2.99' : '$29' }}</div>
              <div v-if="type === 'trial'">
                $0
              </div>
            </div>
          </div>
          <div class="text-lg text-bold mb-1"> {{$lang.messages.get_premium_modal.billing_info}}</div>
          <Stripe :premiumPlan="premiumPlan" :customer="customer" :trial="type === 'trial'"
                  v-on:premiumispurchased = "premiumIsPurchased"
                  v-on:updatesettings = "updateSettings"/>
          <div class="premium-card-info">{{$lang.messages.get_premium_modal.card_text_info}}</div>
        </div>
      </div>
  </div>
</template>

<script>

import Stripe from "@/components/Stripe"
import { getTimeStamp, getMDY } from '../helpers/utils.js'
export default {
  name: 'GetPremiumForm',
  props: {
    customer: Object,
    type: {
      type: String,
      default: 'base'
    },
    initialPremiumPlan: String,

  },
  data: function () {
    return {
      premiumPlan: this.initialPremiumPlan || 'month',
      features: [
        {
          id: 0,
          title: this.$lang.messages.get_premium_modal.features.feture_1_title,
          icon: 'settings',
          text: this.$lang.messages.get_premium_modal.features.feture_1_texts
        },
        {
          id: 1,
          title: this.$lang.messages.get_premium_modal.features.feture_2_title,
          icon: 'themes',
          text: this.$lang.messages.get_premium_modal.features.feture_2_texts
        },
        {
          id: 2,
          title: this.$lang.messages.get_premium_modal.features.feture_3_title,
          icon: 'statistic',
          text: this.$lang.messages.get_premium_modal.features.feture_3_texts
        },
        {
          id: 3,
          title: this.$lang.messages.get_premium_modal.features.feture_4_title,
          icon: 'statistic',
          text: this.$lang.messages.get_premium_modal.features.feture_4_texts
        }
      ],
      trialEndDate: getMDY(new Date().getTime(), 7)
    }
  },
  methods: {
    premiumIsPurchased () {
      getTimeStamp((newTS) => {
        const today = new Date(newTS)
        let premiumEnd
        if(this.premiumPlan === 'month'){
          premiumEnd = today.setMonth(today.getMonth() + 1)
        } else {
          premiumEnd = today.setUTCFullYear(today.getUTCFullYear() + 1)
        }
        this.$emit('premiumispurchased');
        const newSet = {
          'premiumEnd': premiumEnd,
          'isPremium': true
        }
        this.updateSettings(newSet)
      })
    },
    updateSettings(settingsInObj){
      this.$emit('updatesettings', settingsInObj)
    }
  },
  components: {
    Stripe
  }
}

</script>
